var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.settings || (_vm.settings && !_vm.settings.noTitle))?_c('h3',{staticClass:"flix-html-h3"},[_vm._v(" "+_vm._s(_vm.$t('message.preview'))+" ")]):_vm._e(),_c('div',{ref:"calendar"},[_c('flixLoader')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }